import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AccountGroupId } from './account.enum';
import { AppMainComponent } from '../app.main.component';
import { AccountUserService } from '../service/account.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  appUrl = "";
  localAppUrl = "";
  accountApiUrl = '';
  appCore = '';
  timeZoneURL = '';
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  user: any;
  constructor(private http: HttpClient, private accountUserService: AccountUserService) {
    this.accountUserService.user.subscribe(x => this.user = x);
    this.appUrl = environment.apiUrl + "Account/";
    this.accountApiUrl = environment.apiUrlAccount + "Account/";
    this.localAppUrl = environment.localApiUrl;
    this.appCore = environment.baseUrl + "LionO360ApplicationLionOCoreAPI/LionO360/2.0/API/";
    this.timeZoneURL = environment.timeZoneURL;
  }

  getAllCountries() {
    return this.http.get<any>(this.appCore + 'Country/CountryMinified')
      .toPromise()
      .then(res => res);
  }

  getAllCities(stateId: number) {
    return this.http.get<any>(this.appCore + 'City', {
      params: new HttpParams().append("stateId", `${stateId}`)
    })
      .toPromise()
      .then(res => res);
  }

  getAllStates(countryId: number) {
    return this.http.get<any>(this.appCore + 'State', {
      params: new HttpParams().append("countryId", `${countryId}`)
    })
      .toPromise()
      .then(res => res);
  }

  getAllCitiesByMultipleState(stateIds: string) {
    return this.http.get<any>(this.appCore + 'City/CitiesByMultipleStateId', {
      params: new HttpParams().append("stateIds", `${stateIds}`)
    })
      .toPromise()
      .then(res => res);
  }

  getAllAccountsWithPagination(data) {
    let params = new HttpParams();
    params = !data?.pageNo ? params : params.append("PageNumber", data?.pageNo);
    params = !data?.pageSize ? params : params.append("PageSize", data?.pageSize);
    params = !data?.searchValue ? params : params.append("SearchValue", data?.searchValue);
    params = !data?.searchColumns ? params : params.append("SearchColumns", data?.searchColumns);
    params = !data?.sortBy ? params : params.append("SortBy", data?.sortBy);
    params = !data?.isAscending ? params : params.append("IsAscending", data?.isAscending);
    params = !data?.filter ? params : params.append("filter", data?.filter);
    params = params.append("isActive", data?.isActive);
    params = params.append("showBalance", data?.showBalance);
    
    return this.http.get<any>(`${environment.financeURl}FinancialAccount?accountType=0`, { observe: 'response', params })
      .toPromise()
      .then(res => ({
        inventory: res.body,
        headers: JSON.parse(res.headers.get('x-pagination'))
      }));
  }

  getAllStatesByMultipleCountry(countryIds: string) {
    return this.http.get<any>(this.appCore + 'State/StateByMultipleCountryId', {
      params: new HttpParams().append("countryIds", `${countryIds}`)
    })
      .toPromise()
      .then(res => res);
  }



  getAllSalutations() {
    return this.http.get<any>(environment.apiUrl + 'Salutation')
      .toPromise()
      .then(res => res);
  }

  getAllStages(companyID: number) {
    return this.http.get<any>(environment.apiUrlAccount + 'LeadStage', {
      params: new HttpParams().append("companyId", companyID.toString())
    })
      .toPromise()
      .then(res => res);
  }

  getAllIndustries() {
    return this.http.get<any>(this.appCore + 'Industry')
      .toPromise()
      .then(res => res);
  }

  getAllTargets() {
    return this.http.get<any>(environment.apiUrl + 'TargetList')
      .toPromise()
      .then(res => res);
  }

  getAllSocialProfiles(socialProfileType) {
    return this.http.get<any>(environment.apiUrlAccount + 'Type?groupId=' + socialProfileType)
      .toPromise()
      .then(res => res);
  }

  getAllPhoneTypes(phoneType) {
    return this.http.get<any>(environment.contactAPI + '/LionO360/2.0/API/Phone/PhoneType')
      .toPromise()
      .then(res => res);
  }

  getAllEmailTypes() {
    return this.http.get<any>(environment.contactAPI + '/LionO360/2.0/API/Email/EmailType')
      .toPromise()
      .then(res => res);
  }

  getAllAccountTypes(groupId, subterrid = 0) {
    return this.http.get<any>(`${environment.apiUrlAccount}Type?groupId=${groupId}&subTerritoryId=${subterrid||0}`)
      .toPromise()
      .then(res => res);
  }

  getAllRatings() {
    return this.http.get<any>(this.appCore + 'Rating')
      .toPromise()
      .then(res => res);
  }

  getAllOwnerships() {
    return this.http.get<any>(this.appCore + 'Ownership')
      .toPromise()
      .then(res => res);
  }

  getAllEmployeesCount() {
    return this.http.get<any>(this.appCore + 'EmployeeCount')
      .toPromise()
      .then(res => res);
  }

  getAllRevenues() {
    return this.http.get<any>(this.appCore + 'AnnualRevenue')
      .toPromise()
      .then(res => res);
  }

  getAllSources(companyID: number) {
    return this.http.get<any>(environment.apiUrl + 'Source', {
      params: new HttpParams().append("companyId", companyID.toString())
    })
      .toPromise()
      .then(res => res);
  }

  getAllTags(subterrid?) {
    return this.http.get<any>(`${environment.apiUrlAccount}Tag/All?subTerritoryId=${subterrid||0}`)
      .toPromise()
      .then(res => res);
  }

  getAccountDetails(accountId: number) {
    return this.http.get<any>(`${this.accountApiUrl}${accountId}`)
      .toPromise()
      .then(res => res);
  }

  getFoundedYear() {
    return this.http.get<any>(`${environment.apiUrlAccount}FoundedYear`)
      .toPromise()
      .then(res => res);
  }

  getAllAccounts(data) {
    let url = this.accountApiUrl + 'AccountsWithName';

    if(data && data['search']){
      url = url + '?search=' + encodeURIComponent(data['search']);
    }
    if(data && data['search'] && data['channelId']){
      url = url + `&channelId=${data['channelId']}`;
    }
    if(data && !data['search'] && data['channelId']){
      url = url + `?channelId=${data['channelId']}`;
    }
    return this.http.get<any>(url)
      .toPromise()
      .then(res => res);
  }

  getAllAccountsList(data) {
    return this.http.get<any>(this.accountApiUrl + 'All', { observe: 'response', params: { ...data } })
      .toPromise()
      .then(res =>

      ({
        accounts: res.body,
        headers: JSON.parse(res.headers.get('x-pagination'))
      })

      );
  }

  getAllAccountBySearch(pageSize: number, pageNumber: number, companyID: number, userLoginID: number, parentId=0, dateSearch, columns, typeId, stageId?, searchValue?: string, seachFields?: string, options?, objectNamesList?) {
    stageId = stageId ? stageId : 0
    let url = this.accountApiUrl + "?organizationId=" + companyID + "&loginUserId=" +
      userLoginID + "&typeId=" + typeId + "&stageId=" + stageId + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize + "&filter=" + dateSearch + "&isActive=" + options.isActive;
    const checkContactColumn = columns.find(el=>el.field == "contactName");
    if(checkContactColumn && checkContactColumn.show){
      url = url+'&objectNameList=accountcontacts';
    }
    const checkPhonesColumn = columns.find(el=>el.field == "phone");
    if(checkPhonesColumn && checkPhonesColumn.show){
      url = url+'&objectNameList=accountphones';
    }
    const checkAccountTypesColumn = columns.find(el=>el.field == "accountTypesNames");
    if(checkAccountTypesColumn && checkAccountTypesColumn.show){
      url = url+'&objectNameList=accountTypes';
    }
    url = url+"&objectNameList=status&objectNameList=childaccounts&parentAccountId="+parentId
    if (options) {
      if (options.sort) {
        url = `${url}&SortBy=${options.sort.SortBy}&IsAscending=${options.sort.IsAscending}`;
      }
      if(options.moduleSearchValue){
        url = `${url}&moduleSearchValue=${encodeURIComponent(options.moduleSearchValue)}`;
      }
    }
    if (dateSearch != 'recentlyviewedcontacts' && (!options || !options.sort)) {
      url = `${url}&SortBy=createdDate&IsAscending=false`;
    }

    if (searchValue) {
      url = `${url}&SearchValue=${encodeURIComponent(searchValue)}`;
    }
    if (seachFields) {
      url = `${url}&SearchColumns=${seachFields}`;
    }


    return this.http.get<any>(url, {
      observe: 'response'
    })
      .toPromise()
      .then(res =>

      ({
        accounts: res.body,
        headers: JSON.parse(res.headers.get('x-pagination'))
      })

      );
  }

  getAllAccountsCount(companyID, groupID, typeId, filter, options) {
    return this.http.get<any>(this.accountApiUrl + 'Count?organizationId=' + companyID + '&groupId=' + groupID + "&typeId=" + typeId + "&filter=" + filter + '&isActive=' + options.isActive)
      .toPromise()
      .then(res => res);
  }

  deleteAccount(id) {
    return this.http.delete<any>(`${this.accountApiUrl}${id}`)
      .toPromise()
      .then(res => res);
  }

  getStatusComments(id) {
    return this.http.get<any>(this.accountApiUrl + 'StatusAudit?id='+id)
    .toPromise()
    .then(res => res);
  }

  // activeInactiveAccount(id, body){
  //   let url = this.accountApiUrl + 'AccountIsActive/' + id +'?IsActive='+body.isActive+'&comment='+body.comment
  //   return this.http.put(url, body)
  //     .toPromise()
  //     .then(res => res);
  // }

  addAccount(data: any): Promise<any> {
    return this.http.post(this.accountApiUrl, data, {

    }).toPromise();
  }

  updateAccount(c) {
    return this.http.put<any>(this.accountApiUrl, c).toPromise()
  }

  getAccountStages() {
    const groupId = AccountGroupId.ID;
    return this.http.get<any>(`${environment.apiUrlAccount}Category?groupId=${groupId}`)
      .toPromise()
      .then(res => res);
  }

  getLoggedUser(userId) {
    return this.http.get<any>(this.localAppUrl + 'users/' + userId)
      .toPromise()
      .then(res => res);
  }

  getLoggedUserDetails(userId:number) {
    return this.http.get<any>(environment.appOrgUrl + 'User/' + userId)
}

  getAccountContacts(accountId) {
    return this.http.get<any>(this.localAppUrl + 'accountContacts/' + accountId)
      .toPromise()
      .then(res => res);
  }

  getAccountContactNameList(accountId) {
    return this.http.get<any>(`${this.accountApiUrl}Contact?accountId=${accountId}`)
  }

  addContact(c) {
    return this.http.post<any>(environment.contactURL + 'Contact', c)
      .toPromise()
      .then(res => res);
  }

  updateUser(user) {
    return this.http.put(this.localAppUrl + 'users/' + user.id, user, { headers: this.headers })
      .toPromise()
      .then(() => user);
  }

  addDetailsInObject(obj) {
    const res = {};
    function recurse(obj) {
      for (const key in obj) {
        let value = obj[key];
        if (value != undefined) {
          if (value && typeof value === 'object') {
            recurse(value);
          } else {
            // Do your stuff here to var value
            res[key] = value;
          }
        }
      }
    }
    recurse(obj);
    return res;
  }

  getAllAccountContact(accountId) {
    return this.http.get<any>(`${this.accountApiUrl}Contact?accountId=${accountId}`)
      .toPromise()
      .then(res => res);
  }

  getAllAccountFields(companyId){
    return this.http.get<any>(`${this.accountApiUrl}GetAllAccountFields?organizationId=${companyId}`)
      .toPromise()
      .then(res => res);
  }

  uploadAccount({ OrganizationId, CreatedSource, UserId, file }) {
    const formData = new FormData();
    formData.append('filesData', file);
    const url = `${this.accountApiUrl}Import`;
    return this.http.post(url, formData, { responseType: 'text' }).toPromise();
  }

  getAccountDashboardData() {
    return this.http.get<any>(this.localAppUrl + 'accountDashboard')
      .toPromise()
      .then(res => res);
  }

  getTimezone() {
    return this.http.get<any>(`${this.timeZoneURL}TimeZone`)
      .toPromise()
      .then(res => res);
  }

  getTimezoneMinified() {
    return this.http.get<any>(`${this.timeZoneURL}TimeZone/TimeZoneMinified`)
      .toPromise()
      .then(res => res);
  }

  getCurrency() {
    return this.http.get<any>(`${this.appCore}CurrencyUnit`)
      .toPromise()
      .then(res => res);
  }

  getGender() {
    return this.http.get<any>(`${this.appCore}Gender`)
      .toPromise()
      .then(res => res);
  }

  getLanguage() {
    return this.http.get<any>(`${this.appCore}Language`)
      .toPromise()
      .then(res => res);
  }

  getRelationshipStatus() {
    return this.http.get<any>(`${this.appCore}RelationshipStatus`)
      .toPromise()
      .then(res => res);
  }

  getMaritalStatus() {
    return this.http.get<any>(`${this.appCore}MaritalStatus`)
      .toPromise()
      .then(res => res);
  }

  getDegrees() {
    return this.http.get<any>(`${this.appCore}Degree`)
      .toPromise()
      .then(res => res);
  }

  getStudyFields() {
    return this.http.get<any>(`${this.appCore}FieldOfStudy`)
      .toPromise()
      .then(res => res);
  }

  getAllAssistant(companyId) {
    return this.http.get<any>(`${environment.contactAPI}/LionO360/2.0/API/Contact?organizationId=${companyId}`)
      .toPromise()
      .then(res => res);
  }

  getAccountList(organizationId, loginUserId) {
    return this.http.get<any>(`${this.accountApiUrl}AccountsWithName?organizationId=${organizationId}&loginUserId=${loginUserId}&isTerritory=false`);
  }

  getAccountListByTerritory(organizationId, loginUserId, isTerritory) {
    return this.http.get<any>(`${this.accountApiUrl}AccountsWithName?organizationId=${organizationId}&loginUserId=${loginUserId}&isTerritory=${isTerritory}`);
  }

  getAddressTypes() {
    return this.http.get<any>(this.appCore + 'Address/AddressType')
      .toPromise()
      .then(res => res);
  }

  getModules() {
    return this.http.get<any>(environment.configUrl + "LionO360_Object")
      .toPromise()
      .then(res => res);
  }
  getAllCustomFieldTypes(id) {
    return this.http.get<any>(environment.configUrl + "Configuration/FormControls?objectId="+id)
      .toPromise()
      .then(res => res);
  }
  getAllCustomFields(id) {
    return this.http.get<any>(environment.configUrl + 'Configuration/CustomAttributes?objectId=' + id)
      .toPromise()
      .then(res => res);
  }

  getAccountConfigurations(){
    return this.http.get<any>( `${environment.configUrl}Configuration/ConfigurationsByModuleName?name=Account`)
  }

  getAccountColumnsSetings(templateId, objectId) {
    return this.http.get<any>(`${environment.configUrl}Configuration/ColumnSetting/${templateId}?objectId=${objectId}`)
  }

  getAccounAddressTypes(){
    return this.http.get<any>( `${environment.coreUrl}Address/AddressTypeMinified`);
  }

  getAccountAddressClasses(){
    return this.http.get<any>( `${environment.coreUrl}Address/AddressClassMinified`);
  }

  addAccounAddressType(data){
    return this.http.post<any>( `${environment.coreUrl}Type`, data);
  }

  getallTerritoryAccounts(templateId,pageNumber,pageSize,searchValue,loginUserId,organizationId, fieldList?) {

    let fieldListStr ="";

    if(fieldList){
        fieldListStr =`&fieldList=${fieldList}`;
    }
    let url= '&SearchValue='+encodeURIComponent(searchValue)+'&SearchColumns=businessName&loginUserId='+loginUserId+'&typeId='+templateId+'&stageId=0&pageNumber='+pageNumber+'&pageSize='+pageSize+'&filter=allaccounts&isActive=true&objectNameList=status&objectNameList=childaccounts&parentAccountId=0&SortBy=createdDate&IsAscending=false'
    let urls = this.accountApiUrl + 'TerrritoryAccount?organizationId='+organizationId+ url+fieldListStr;
    //fieldList="field1,field2"
    return this.http.get<any>(urls, {
      observe: 'response'
    })
      .toPromise()
      .then(res =>

      ({
        contacts: res.body,
        headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false}
      })

      );
}

    getActiveInactiveDataByName(name) {
        return this.http.get<any>(`${environment.apiUrlAccount}Group/Name?name=` + name);
    }

    getActiveInactiveReasons(groupId) {
        return this.http.get<any>(`${environment.coreUrl}Category/GetAllCategoryOrganizationWise?groupId=` + groupId);
    }

    addActiveInactiveReason(data) {
        return this.http.post<any>(`${environment.coreUrl}Category`, data);
    }

    updateActiveInactiveReason(data) {
        return this.http.put<any>(`${environment.coreUrl}Category`, data);
    }

    deleteActiveInactiveReason(id) {
        return this.http.delete<any>(`${environment.coreUrl}Category/${id}`);
    }

    activeInactiveAccount(id, data){
      let url = `${this.accountApiUrl}ChangeActiveInactiveStatus/${id}`;
      return this.http.post(url, data)
        .toPromise()
        .then(res => res);
   }

   //Inventory
   getAllInventoryDetails(accountId){
    return this.http.get<any>(`${environment.apiUrlAccount}Account/AccountInventoryDetails/${accountId}`);
  }

  getAllPriceBookDetails(accountId){
    return this.http.get<any>(`${environment.apiUrlAccount}AccountProductPriceTier/PriceTierByAccountAndType?accountId=${accountId}`);
  }

  getPriceTierList() {
    return this.http.get<any>(`${environment.inventoryURl}PriceTier/PriceTierConfiguration`);
  }

  deleteTier(id) {
    return this.http.delete<any>(`${environment.apiUrlAccount}AccountProductPriceTier/${id}`)
        .toPromise()
        .then(res => res);
}

updateAccountPriceTier(data) {
  return this.http.put<any>(`${environment.apiUrlAccount}AccountProductPriceTier/EditBulkAccountProductPriceTier`, data)
      .toPromise()
      .then(res => res);
}

getPaymentTermList() {
  return this.http.get<any>(`${environment.inventoryURl}PaymentTerm`);
}

getPaymentMethodList() {
  return this.http.get<any>(`${environment.inventoryURl}PaymentMethod`);
}

getShippingTermList() {
  return this.http.get<any>(`${environment.inventoryURl}ShippingTerm`);
}

getShippingMethodList() {
  return this.http.get<any>(`${environment.inventoryURl}ShippingMethod/ShippingMethodHierarchy`);
}

getFOBList() {
  return this.http.get<any>(`${environment.inventoryURl}FOBPoint`);
}

getAllLocations(): Observable<any>{
  let params = new HttpParams();
  params = params.append('PageNumber', '0')
  params = params.append('PageSize', '0')
  params = params.append('SearchValue', '')
  return this.http.get<any>(`${environment.inventoryURl}WareHouse/AllWarehouseDetails`, { params });
}

getAllItems(pageNo,pageSize,typeId,discountTypeId,categoryId,warehouseId,searchValue){
  let params = new HttpParams();
  params = params.append('PageNumber', pageNo)
  params = params.append('PageSize', pageSize)
  params = params.append('typeId', typeId)
  params = params.append('tierTypeId', discountTypeId)
  params = (categoryId ? params.append('categoryId', categoryId) : params)
  params = (warehouseId ? params.append('warehouseId', warehouseId) : params)
  params = (searchValue ? params.append('SearchValue', searchValue) : params)
   return this.http.get<any>(`${environment.inventoryURl}PriceTier/CustomProducts`,{observe: 'response',params})
       .toPromise()
       .then(res=> ({
           items: res.body,
           headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false});
       }))
}

getInventoryGroupList() {
  return this.http.get<any>(`${environment.inventoryURl}Group`);
}

getInventoryCategoryList(groupId) {
  return this.http.get<any>(`${environment.inventoryURl}Category/CategoryHierarchy?groupId=${groupId}`);
}

updateAccountInventoryDetails(data){
  return this.http.put<any>(`${environment.apiUrlAccount}AccountInventorySetup/EditAccountInventorySetup`, data)
  .toPromise()
  .then(res => res);
}

loadAccountPaymentMethods(accountId){
  return this.http.get<any>(`${environment.apiUrlAccount}AccountPaymentMethodSubDetail?accountId=${accountId}`);
}

addAccountPayMethod(data){
  return this.http.post<any>(`${environment.apiUrlAccount}AccountPaymentMethodSubDetail`, data)
  .toPromise()
  .then(res => res);
}

updateAccountPayMethod(data){
  return this.http.put<any>(`${environment.apiUrlAccount}AccountPaymentMethodSubDetail`, data)
  .toPromise()
  .then(res => res);
}

makeDefaultPayMethod(accountPayMethodId,methodId){
  return this.http.get<any>(`${environment.apiUrlAccount}AccountPaymentMethodSubDetail/SetDefaultAccount?accountPaymentMethodId=${accountPayMethodId}&Id=${methodId}`);
}

getAccountPayMethodRelation(accountId,subDetailId) {
  return this.http.get<any>(`${environment.apiUrlAccount}AccountPaymentMethodParentChildRelation/ParentAccount/${accountId}/SubDetail/${subDetailId}`);
}

saveAccountPayMethodRelation(relationshipData) {
  return this.http.post<any>(`${environment.apiUrlAccount}AccountPaymentMethodParentChildRelation`, relationshipData)
}

makeDefaultPayTerm(accountId,termId){
  return this.http.get<any>(`${environment.apiUrlAccount}AccountPaymentTerm/SetDefaultAccountPaymentTerm?accountId=${accountId}&Id=${termId}`);
}

makeDefaultShipMethod(accountId,methodId){
  return this.http.get<any>(`${environment.apiUrlAccount}AccountShippingMethod/SetDefaultAccountShipping?accountId=${accountId}&Id=${methodId}`);
}

deleteAccountPaymentMethod(id,accountId){
  let params = new HttpParams();
  params = accountId ? params.append('accountId', accountId) : params;
  return this.http.delete<any>(`${environment.apiUrlAccount}AccountPaymentMethodSubDetail/${id}`, {params})
  .toPromise()
  .then(res => res);
}

addCity(data: object) {
  return this.http.post<any>(`${environment.coreUrl}City`, data)
  .toPromise()
  .then(res => res);
}

getCountry() {
  return this.http.get<any>(`${environment.coreUrl}Country`);
}

addState(data: object) {
  return this.http.post<any>(`${environment.coreUrl}State`, data)
  .toPromise()
  .then(res => res);
}

 //update Credit data
 updateAccountCreditData(accountId,data){
  return this.http.put<any>(`${environment.apiUrlAccount}AccountInventorySetup/UpdateAccount?id=${accountId}`, data)
  .toPromise()
  .then(res => res);
 }

}
